export default __webpack_public_path__ + "static/media/boxtype20.b5f98460.JPG";